import { render, staticRenderFns } from "./OnboardingAdministrativeDocsPage.vue?vue&type=template&id=107ca118&"
import script from "./OnboardingAdministrativeDocsPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingAdministrativeDocsPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingAdministrativeDocsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports